import React from 'react';
import SimilarJobTitleCard from '@/components/job-title/similar-job-title/Card';
import MobileSwiper from '@/components/mobile/MobileSwiper';
import SeoSwiper from '@/components/swiper/SeoSwiper';
import { useClintMediaQuery } from '@/utils/hooks';
import { CityContext } from '@/context/create-context';

export type HotSimilarJobTitlesType = {
  id: string;
  name: string;
  avg: number;
  description: string;
}[];

const HotSimilarJobTitle = (props: { data: HotSimilarJobTitlesType }) => {
  const { data } = props;
  const isMobile = useClintMediaQuery();
  const { name: cityName, pinyin: cityPinyin } = React.useContext(CityContext);

  if (!Array.isArray(data) || !data.length) {
    return null;
  }

  return (
    <div className="w-full mb-12">
      <h2 className="text-2xl font-semibold mb-5">{`${cityName}热门职位数据`}</h2>
      <div className="mt-5 tablet:mt-6">
        {isMobile ? (
          <MobileSwiper
            chunkData={data}
            chunkSize={6}
            slideClassName="grid grid-cols-2 grid-rows-3 gap-y-4 gap-x-3 m-0 mt-6"
            swiperEle={({ id, name, avg, description }) => (
              <SimilarJobTitleCard
                key={id}
                id={id}
                name={name}
                salary={avg || NaN}
                city={{ name: cityName, pinyin: cityPinyin }}
                description={description}
              />
            )}
            tag="ul"
          />
        ) : (
          <SeoSwiper
            chunkData={data}
            swiperEle={({ id, name, avg, description }) => (
              <SimilarJobTitleCard
                key={id + avg}
                id={id}
                name={name}
                salary={avg || NaN}
                city={{ name: cityName, pinyin: cityPinyin }}
                description={description}
              />
            )}
          />
        )}
      </div>
    </div>
  );
};

export default HotSimilarJobTitle;
